import angular from 'angular';

module.exports = angular.module('market.services.unprocessable-entity-modal', [])
.factory('UnprocessableEntityModal', function($q, $rootScope) {
  return {
    responseError: function(rejection) {
      if (rejection.status === 422) {
        var url = '/customers/' + rejection.config.data.token;
        $rootScope.modal('There was an error saving your progress. ' +
          'Please <a href="' + url + '" target="_self">reload the page</a>.');
      }
      return $q.reject(rejection);
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/services/unprocessable-entity-modal.js
 **/